import HeartWithBorder from '~/icons/HeartWithBorder';
import HeartWithBorderThin from '~/icons/HeartWithBorderThin';

export default function FavoritesToastContent({
  action
}: {
  action: 'add' | 'remove';
}) {
  const isRemove = action === 'remove';
  const text = isRemove
    ? 'Removed from your favorites'
    : 'Added to your favorites';

  return (
    <div className="flex items-center justify-between gap-md t-heading-sm">
      {isRemove ? (
        <HeartWithBorder darkGray className="h-16 w-16" />
      ) : (
        <HeartWithBorderThin className="h-20 w-20" isFavorited />
      )}
      <span className="whitespace-nowrap">{text}</span>
    </div>
  );
}
